import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/core/services/http.service';
import { Params } from './pages/list/models/params.model';
import { TransferParams } from '../transfer/models/transfer-params.model';

@Injectable({
  providedIn: 'root'
})
export class MerchantsGeneralService {

  private getUrl = 'merchants/general/get';
  private registerUrl = 'merchants/general/register';
  private banksUrl = 'merchants/general/banks';
  private paymentsConditionUrl = 'merchants/general/payments-conditions';
  private getItemsCategoriesUrl = 'merchants/general/get-items-categories';
  private saveItemsCategoriesUrl = 'merchants/general/save-items-categories';
  private saveNameUrl = 'merchants/general/save-name';
  private saveUserUrl = 'merchants/general/save-user';
  private saveInfoAccountUrl = 'merchants/general/save-info-account';
  private saveBankDataUrl = 'merchants/general/save-bank-data';
  private saveColroUrl = 'merchants/general/save-color';
  private getStatesUrl = 'merchants/general/states';

  constructor(private httpService: HttpService) { }

  get(partner: string, account: string, merchantID: string, loading = true) {

    const params = {
      merchant_id: merchantID
    };

    return this.httpService.postMerchant(this.getUrl, params, partner, account, merchantID, loading);
  }

  register(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.registerUrl, params, partner, account, merchant);
  }

  listBanks(partner: string, account: string, merchant, loading = true) {
    return this.httpService.getMerchant(this.banksUrl, partner, account, merchant, loading);
  }

  listPaymentsConditions(partner: string, account: string, merchant, loading = true) {
    return this.httpService.getMerchant(this.paymentsConditionUrl, partner, account, merchant, loading);
  }

  saveName(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.saveNameUrl, params, partner, account, merchant);
  }

  saveUser(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.saveUserUrl, params, partner, account, merchant);
  }

  saveInfoAccount(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.saveInfoAccountUrl, params, partner, account, merchant);
  }

  saveBankData(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.saveBankDataUrl, params, partner, account, merchant);
  }

  saveColor(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.saveColroUrl, params, partner, account, merchant);
  }

  getItemsCategories(partner, account, merchantExternalId) {

    const params = {
      merchant_external_id: merchantExternalId
    };

    return this.httpService.postMerchant(this.getItemsCategoriesUrl, params, partner, account, merchantExternalId);
  }

  saveItemsCategories(partner, account, merchant, params) {
    return this.httpService.postMerchant(this.saveItemsCategoriesUrl, params, partner, account, merchant);
  }

  getStates(partner: string, account: string, merchant, countryId: number) {
    const params = {
      country_id: countryId
    };
    return this.httpService.postMerchant(this.getStatesUrl, params, partner, account, merchant, false);
  }


}
